// extracted by mini-css-extract-plugin
export default {"popupWrapper":"RulesBoxDescription_popupWrapper__PmJs3","parentDiv":"RulesBoxDescription_parentDiv__-FhjK","contentDiv":"RulesBoxDescription_contentDiv__6sVgr"};